import "./index.scss";
import { nanoid } from "nanoid"

export const GoogleRating: React.FC<{ count?: number; size?: number | string }> = ({
    count = 0,
    size = 18,
}) => {
    const arrayDefault = Array(5).fill(0);
    function adjustDecimal(value: number) {
        // Separate integer and decimal parts
        const number = Number(value.toFixed(2));
        const integerPart = Math.trunc(number);
        const decimalPart = number - integerPart;

        // Adjust the decimal part based on the condition
        let adjustedDecimal = decimalPart;
        if (decimalPart > 0.25 && decimalPart < 0.7) {
            adjustedDecimal = 0.5;
        }
        if (decimalPart <= 0.24) {
            adjustedDecimal = 0;
        }
        if (decimalPart > 0.7) {
            adjustedDecimal = (1 - decimalPart) + decimalPart;
        }
        // Combine back the integer and adjusted decimal parts
        return integerPart + adjustedDecimal;
    }

    return <div className="rating">
        {arrayDefault.map((val, _index) => {
            const decimalPart = adjustDecimal(count);
            return <div key={`rating-${nanoid()}`}>
                {(_index <= decimalPart && decimalPart % 1 == 0) ? <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={_index + 1 <= decimalPart ? '#FDBD2E' : '#D3D3D3'} width={size} height={size}>
                    <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.45 21L12 17.77L6.55 21L8 14.14L3 9.27L9.91 8.26L12 2Z" />
                </svg> :
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size}>
                        <defs>
                            <clipPath id="half">
                                <rect x="0" y="0" width="12" height="24" />
                            </clipPath>
                        </defs>
                        <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.45 21L12 17.77L6.55 21L8 14.14L3 9.27L9.91 8.26L12 2Z" fill={(_index + 1 < decimalPart) ? '#FDBD2E' : '#D3D3D3'} />
                        {(decimalPart % 1 != 0 && _index <= decimalPart) && <path d="M12 2L14.09 8.26L21 9.27L16 14.14L17.45 21L12 17.77L6.55 21L8 14.14L3 9.27L9.91 8.26L12 2Z" fill="#FDBD2E" clip-path="url(#half)" />}
                    </svg>
                }
            </div>
        })}
    </div>
}